import { RefObject, useEffect, useRef, useState } from "react"

export default function useInView<T extends Element>(
  threshold = 0.3,
): [RefObject<T>, boolean] {
  const ref = useRef<T>(null)
  const [isInView, setIsInView] = useState(false)

  useEffect(() => {
    const element = ref.current
    if (!element || isInView) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsInView(true)
      },
      { threshold },
    )
    observer.observe(element)

    return () => observer.disconnect()
  }, [isInView, threshold])

  return [ref, isInView]
}
